import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useUploadIcon } from 'queries/Media';
import { editProfileApi } from './api';

const useEditMyProfile = () => {
  const queryClient = useQueryClient();
  const { uploadIconMutate } = useUploadIcon();

  const { mutateAsync: editMyProfileMutate } = useMutation(
    ['editMyProfile'],
    async ({ dataForm, profileId }) => {
      const body = {
        email: dataForm.email,
        iconId: await uploadIconMutate({ file: dataForm.iconId }),
        name: dataForm.name,
        surname: dataForm.surname,
        username: dataForm.username,
      };

      await editProfileApi({ profileId, body });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['myProfile']);
      },
    }
  );

  return { editMyProfileMutate };
};

export default useEditMyProfile;
